<template>
  <v-container>
    <TomesProgressLinear></TomesProgressLinear>
    <v-spacer></v-spacer>
    <GenericChecklist @increment="increment" @decrement="decrement" :headers="[{text:'completed', value:'completed'},{text:'area', value:'area_id'}]" :items="filtered" :itemKey="'area_id'"></GenericChecklist>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import GenericChecklist from '@/components/GenericChecklist'
import TomesProgressLinear from "@/components/TomesProgressLinear";


export default {
  name: "Tomes",
  components: { TomesProgressLinear, GenericChecklist },
  computed: {
    ...mapGetters("entities/tomes",["filtered"])
  },
  methods: {
    ...mapActions("entities/tomes", ["increment", "decrement"]),
  },
};
</script>
